import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "mydiv",
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = {
  id: "divAdminUser",
  class: "divAdminUser"
}
const _hoisted_4 = {
  id: "tblAdminUser",
  style: {"border":"none"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "userId",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("User ID "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { style: {"text-align":"left"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_8 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_9 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "userId",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Employee Number "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_11 = { style: {"text-align":"left"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_14 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_15 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "givenName",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Given Name "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_17 = { style: {"text-align":"left"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_20 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_21 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "familyName",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Family Name "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_23 = { style: {"text-align":"left"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_26 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_27 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "email",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("E-mail "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_29 = { style: {"text-align":"left"} }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_32 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_33 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "department",
    style: {"margin-right":"8%"}
  }, "Department   ")
], -1 /* HOISTED */)
const _hoisted_35 = { style: {"text-align":"left"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_38 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_39 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "department",
    style: {"margin-right":"8%"}
  }, "Title   ")
], -1 /* HOISTED */)
const _hoisted_41 = { style: {"text-align":"left"} }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_44 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_45 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "title",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Station Code "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_47 = { style: {"text-align":"left"} }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_50 = { style: {"text-align":"left","line-height":"20px"} }
const _hoisted_51 = { style: {"text-align":"left","color":"red","width":"100%"} }
const _hoisted_52 = { style: {"margin-left":"30%","margin-right":"30%"} }
const _hoisted_53 = { class: "mb-3 row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading.value == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.pageTitle }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tr", null, [
          _hoisted_5,
          _createElementVNode("td", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "userId",
              maxlength: "8",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.userId]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_7,
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString($setup.userIdError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "empNumber",
              maxlength: "6",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.empNumber) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.empNumber]
            ])
          ]),
          _hoisted_12
        ]),
        _createElementVNode("tr", null, [
          _hoisted_13,
          _createElementVNode("td", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString($setup.empNumberError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_16,
          _createElementVNode("td", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "givenName",
              maxlength: "100",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.givenName) = $event)),
              onKeydown: _cache[3] || (_cache[3] = ($event: any) => ($setup.txtOnKeyDown($event))),
              onKeyup: _cache[4] || (_cache[4] = ($event: any) => ($setup.checkAlphabet($event))),
              onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.checkAlphabet($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.givenName]
            ])
          ]),
          _hoisted_18
        ]),
        _createElementVNode("tr", null, [
          _hoisted_19,
          _createElementVNode("td", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString($setup.givenNameError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_22,
          _createElementVNode("td", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "familyName",
              maxlength: "100",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.familyName) = $event)),
              onKeydown: _cache[7] || (_cache[7] = ($event: any) => ($setup.txtOnKeyDown($event))),
              onKeyup: _cache[8] || (_cache[8] = ($event: any) => ($setup.checkAlphabet($event))),
              onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.checkAlphabet($event)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.familyName]
            ])
          ]),
          _hoisted_24
        ]),
        _createElementVNode("tr", null, [
          _hoisted_25,
          _createElementVNode("td", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString($setup.familyNameError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_28,
          _createElementVNode("td", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "email",
              maxlength: "100",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.email) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.email]
            ])
          ]),
          _hoisted_30
        ]),
        _createElementVNode("tr", null, [
          _hoisted_31,
          _createElementVNode("td", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString($setup.emailError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_34,
          _createElementVNode("td", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "department",
              maxlength: "100",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.department) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.department]
            ])
          ]),
          _hoisted_36
        ]),
        _createElementVNode("tr", null, [
          _hoisted_37,
          _createElementVNode("td", _hoisted_38, [
            _createElementVNode("span", _hoisted_39, _toDisplayString($setup.deptError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_40,
          _createElementVNode("td", _hoisted_41, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"height":"30px","width":"50%"},
              id: "title",
              maxlength: "100",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.title) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.title]
            ])
          ]),
          _hoisted_42
        ]),
        _createElementVNode("tr", null, [
          _hoisted_43,
          _createElementVNode("td", _hoisted_44, [
            _createElementVNode("span", _hoisted_45, _toDisplayString($setup.titleError), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_46,
          _createElementVNode("td", _hoisted_47, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"text-transform":"uppercase","height":"30px","width":"50%"},
              id: "StationCode",
              maxlength: "4",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.StationCode) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.StationCode]
            ])
          ]),
          _hoisted_48
        ]),
        _createElementVNode("tr", null, [
          _hoisted_49,
          _createElementVNode("td", _hoisted_50, [
            _createElementVNode("span", _hoisted_51, _toDisplayString($setup.stationError), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btnBack",
          onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.backbtnEvt()))
        }, " Back "),
        _createElementVNode("button", {
          class: "btn btn-primary btnAdd",
          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.AddProcess()))
        }, " Add ")
      ])
    ])
  ]))
}